export const getCurrentVideo = () => {
  return localStorage.getItem("currentScreenSaver");
};

export const getRunExperience = () => {
  return localStorage.getItem("runExperience");
};

export const setCurrentVideo = (
  currentVideo: string,
  runExperience: boolean
) => {
  return (
    localStorage.setItem("currentScreenSaver", currentVideo),
    localStorage.setItem("runExperience", runExperience.toString())
  );
};

export const setSelectedScenario = (
  currentScenario: string,
) => {
  return (
    localStorage.setItem("currentScenario", currentScenario)
  );
};

export const getCurrentScenario = () => {
  return localStorage.getItem("currentScenario");
};
